
import { BaseBackgroundEffect } from '../BaseBackgroundEffect';
import { BackgroundContext } from '../BackgroundEffect';

export class StarfieldBackground extends BaseBackgroundEffect {
    private stars: {x: number, y: number, size: number, brightness: number}[] = [];

    private init(bc: BackgroundContext) {
        if (this.stars.length > 0) return;
        for (let i = 0; i < 200; i++) {
            this.stars.push({
                x: Math.random() * bc.width,
                y: Math.random() * bc.height,
                size: Math.random() * 2,
                brightness: Math.random()
            });
        }
    }

    public render(bc: BackgroundContext): void {
        const { ctx, width, height, time } = bc;
        this.init(bc);

        // Fill background
        ctx.fillStyle = bc.config.backgroundPrimaryColor;
        ctx.fillRect(0, 0, width, height);

        ctx.fillStyle = '#ffffff';
        this.stars.forEach(s => {
            const opacity = 0.5 + 0.5 * Math.sin(time * 2 + s.brightness * 10);
            ctx.globalAlpha = opacity;
            ctx.beginPath();
            ctx.arc(s.x, s.y, s.size, 0, Math.PI * 2);
            ctx.fill();
        });
        ctx.globalAlpha = 1.0;
    }
}
